// Mock data for PT. Ids Sun Teknik

export const companyInfo = {
  name: "PT. Ids Sun Teknik",
  tagline: "Solusi Terpercaya untuk Kontraktor Mekanik & Elektrikal",
  rating: 5.0,
  reviewCount: 3,
  address: "Jl. Raya Pekanbaru – Bangkinang, Kumantan, Kec. Bangkinang, Kabupaten Kampar, Riau 28463, Indonesia",
  phone: "021-54313816",
  email: "info@idssunteknik.co.id",
  businessHours: "Senin - Minggu: 09:00 - 17:00",
  locationCode: "923Q+C6 Kumantan, Kampar Regency, Riau, Indonesia",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15958.234567890123!2d101.088!3d0.401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMMKwMjQnMDMuNiJOIDEwMcKwMDUnMTYuOCJF!5e0!3m2!1sen!2sid!4v1234567890123!5m2!1sen!2sid",
  heroImages: [
    "https://images.unsplash.com/photo-1487491424367-7571f9afbb30",
    "https://images.unsplash.com/photo-1527335988388-b40ee248d80c",
    "https://images.unsplash.com/photo-1759692071712-adc78a8516c8"
  ]
};

export const certification = {
  certificateNo: "IS0094",
  referenceNo: "QSI/QMS/IS0094",
  standard: "ISO 9001:2008",
  status: "AKTIF",
  state: "RIAU",
  city: "KAMPAR",
  scope: "Penyediaan Kontraktor Umum dalam Bidang Mekanik dan Elektrikal"
};

export const services = [
  {
    id: 1,
    title: "Instalasi Mekanikal",
    description: "Perencanaan dan instalasi sistem mekanikal untuk bangunan komersial, industri, dan residensial dengan standar kualitas tinggi.",
    icon: "settings",
    image: "https://images.unsplash.com/photo-1765850262030-1ae93e474473?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtZWNoYW5pY2FsJTIwc3lzdGVtc3xlbnwwfHx8fDE3NjYxNDYyMzl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Instalasi Elektrikal",
    description: "Instalasi sistem kelistrikan lengkap termasuk panel listrik, pengkabelan, dan sistem distribusi daya yang aman dan efisien.",
    icon: "zap",
    image: "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc2NjE0NjIzNHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Pemeliharaan & Servis",
    description: "Layanan pemeliharaan berkala dan perbaikan untuk sistem mekanikal dan elektrikal guna memastikan performa optimal.",
    icon: "wrench",
    image: "https://images.unsplash.com/photo-1595856898575-9d187bd32fd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFpbnRlbmFuY2V8ZW58MHx8fHwxNzY2MTQ2MjQ1fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Konsultasi Teknik",
    description: "Konsultasi profesional untuk perencanaan proyek, analisis sistem, dan solusi teknik yang sesuai dengan kebutuhan Anda.",
    icon: "clipboardList",
    image: "https://images.pexels.com/photos/416423/pexels-photo-416423.jpeg"
  },
  {
    id: 5,
    title: "Pengadaan Material",
    description: "Penyediaan material berkualitas dari supplier terpercaya untuk memastikan hasil kerja yang maksimal dan tahan lama.",
    icon: "package",
    image: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg"
  },
  {
    id: 6,
    title: "Manajemen Proyek",
    description: "Pengelolaan proyek konstruksi secara menyeluruh dari tahap perencanaan hingga serah terima dengan sistem monitoring yang ketat.",
    icon: "briefcase",
    image: "https://images.unsplash.com/photo-1759692071969-c32285cffc40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxtZWNoYW5pY2FsJTIwc3lzdGVtc3xlbnwwfHx8fDE3NjYxNDYyMzl8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Budi Santoso",
    position: "Direktur PT. Karya Mandiri",
    rating: 5,
    comment: "PT. Ids Sun Teknik sangat profesional dalam menangani proyek instalasi elektrikal kami. Hasilnya memuaskan dan selesai tepat waktu. Sangat direkomendasikan!",
    date: "Januari 2024"
  },
  {
    id: 2,
    name: "Siti Nurhaliza",
    position: "Manajer Operasional, CV. Riau Jaya",
    rating: 5,
    comment: "Pelayanan yang sangat baik dan tim yang berpengalaman. Mereka memberikan solusi terbaik untuk kebutuhan mekanikal pabrik kami. Terima kasih PT. Ids Sun Teknik!",
    date: "Februari 2024"
  },
  {
    id: 3,
    name: "Ahmad Rizki",
    position: "Owner, Kompleks Ruko Kampar",
    rating: 5,
    comment: "Sangat puas dengan hasil kerja PT. Ids Sun Teknik. Instalasi listrik untuk kompleks ruko saya dikerjakan dengan sangat rapi dan aman. Highly recommended!",
    date: "Maret 2024"
  }
];

export const aboutContent = {
  overview: "PT. Ids Sun Teknik adalah perusahaan kontraktor profesional yang bergerak di bidang mekanikal dan elektrikal, berlokasi di Kampar, Riau. Dengan sertifikasi ISO 9001:2008, kami berkomitmen untuk memberikan layanan terbaik dengan standar kualitas internasional.",
  mission: "Menyediakan solusi konstruksi mekanikal dan elektrikal yang berkualitas tinggi, aman, dan efisien untuk mendukung pembangunan infrastruktur di Indonesia.",
  vision: "Menjadi perusahaan kontraktor mekanikal dan elektrikal terkemuka di Indonesia yang dikenal akan profesionalisme, kualitas, dan kepercayaan.",
  teamImage: "https://images.unsplash.com/photo-1709715357520-5e1047a2b691",
  officeImage: "https://images.unsplash.com/photo-1622675363311-3e1904dc1885",
  values: [
    {
      title: "Profesionalisme",
      description: "Bekerja dengan standar profesional tinggi dan mengutamakan kepuasan klien."
    },
    {
      title: "Kualitas",
      description: "Menggunakan material terbaik dan tenaga ahli berpengalaman untuk hasil optimal."
    },
    {
      title: "Keamanan",
      description: "Menerapkan prosedur K3 yang ketat untuk keselamatan kerja di setiap proyek."
    },
    {
      title: "Kepercayaan",
      description: "Membangun hubungan jangka panjang dengan klien melalui transparansi dan integritas."
    }
  ]
};

export const whyChooseUs = [
  {
    title: "Bersertifikat ISO 9001:2008",
    description: "Standar manajemen mutu internasional yang terjamin"
  },
  {
    title: "Tim Berpengalaman",
    description: "Tenaga ahli dan teknisi bersertifikat dengan pengalaman bertahun-tahun"
  },
  {
    title: "Harga Kompetitif",
    description: "Penawaran harga yang terjangkau tanpa mengurangi kualitas"
  },
  {
    title: "Garansi Pekerjaan",
    description: "Jaminan kualitas dan after-sales service yang memuaskan"
  }
];
